import React from 'react'
import { makeStyles } from '@mui/styles'
import { styled, Theme } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Fade from '@mui/material/Fade'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/CancelOutlined'
import Checkbox from '../../control/Checkbox'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'
import { ReactComponent as LayerIcon } from '../../icon/layer.svg'

const PinStationImg = `${process.env.REACT_APP_IMAGE_PATH}/assets/image/pin_station.png`

type MapLayerProps = {
    onCheckPinLayer: () => void
    onCheckCoverageAreaLayer: () => void
    onCheckAntennaPatternLayer: () => void
    isCheckPinLayer: boolean
    isCheckCoverageAreaLayer: boolean
    isCheckAntennaPatternLayer: boolean
}

const MapLayer = (props: MapLayerProps) => {
    const {
        onCheckPinLayer,
        onCheckCoverageAreaLayer,
        onCheckAntennaPatternLayer,
        isCheckPinLayer,
        isCheckCoverageAreaLayer,
        isCheckAntennaPatternLayer,
    } = props
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
    const [open, setOpen] = React.useState(false)
    const classes = useStyles()
    const { t } = useTranslation()

    const onClickOpen = () => (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
        setOpen(true)
    }

    const onClickClose = () => () => {
        setOpen(false)
    }

    return (
        <Paper sx={{ mb: '10px', boxShadow: 'none' }}>
            <Tooltip title={t('LABEL.MAP.TOOLS.LAYER') ?? ''} placement="left">
                <IconButton
                    sx={{ p: '10px', bgcolor: '#fff', borderRadius: '5px', width: '100%' }}
                    aria-label="directions"
                    onClick={open ? onClickClose() : onClickOpen()}
                >
                    <LayerIcon className={classes.iconColor} />
                </IconButton>
            </Tooltip>
            <Popper open={open} anchorEl={anchorEl} placement="bottom-end" transition>
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper className={classes.paper}>
                            <StyledDivTitle>
                                <div>
                                    <Typography gutterBottom component="div" className={classes.labelTitle}>
                                        {t('LABEL.MAP.MAP_LAYER.DATALAYER_FOR_DETAIL')}
                                    </Typography>
                                </div>
                                <div>
                                    <IconButton onClick={onClickClose()}>
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                            </StyledDivTitle>
                            <StyledDivContent>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <div>
                                            <Checkbox
                                                name="pinLayer"
                                                label={t('LABEL.MAP.MAP_LAYER.PIN_LAYER')}
                                                labelPlacement="end"
                                                checked={isCheckPinLayer}
                                                onClick={onCheckPinLayer}
                                                overrideClass={{
                                                    root: classes.checkbox,
                                                    checked: classes.checkboxChecked,
                                                }}
                                                classNameLabel={classes.labelCheckbox}
                                            />
                                        </div>
                        
                                        <div style={{display:'block', marginLeft:26}}>
                                            <IconPinStation src={PinStationImg} />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Checkbox
                                            name="coverageLayer"
                                            label={t('LABEL.MAP.MAP_LAYER.COVERAGE_LAYER')}
                                            labelPlacement="end"
                                            checked={isCheckCoverageAreaLayer}
                                            onClick={onCheckCoverageAreaLayer}
                                            overrideClass={{ root: classes.checkbox, checked: classes.checkboxChecked }}
                                            classNameLabel={classes.labelCheckbox}
                                        />
                                        <div className={classes.listContent}>
                                            <Typography
                                                gutterBottom
                                                component="div"
                                                style={{ paddingTop: '8px' }}
                                                className={classes.labelSubCheckbox}
                                            >
                                                <div
                                                    className={classes.labelSquare}
                                                    style={{ backgroundColor: '#A0CD59' }}
                                                ></div>{' '}
                                                {`${t('LABEL.MAP.MAP_LAYER.RECEIVE_SIGNAL')} 95 - 100%`}
                                            </Typography>
                                            <Typography
                                                gutterBottom
                                                component="div"
                                                style={{ paddingTop: '8px' }}
                                                className={classes.labelSubCheckbox}
                                            >
                                                <div
                                                    className={classes.labelSquare}
                                                    style={{ backgroundColor: '#F6D167' }}
                                                ></div>{' '}
                                                {`${t('LABEL.MAP.MAP_LAYER.RECEIVE_SIGNAL')} 90 - 95%`}
                                            </Typography>
                                            <Typography
                                                gutterBottom
                                                component="div"
                                                style={{ paddingTop: '8px' }}
                                                className={classes.labelSubCheckbox}
                                            >
                                                <div
                                                    className={classes.labelSquare}
                                                    style={{ backgroundColor: '#FFADAD' }}
                                                ></div>{' '}
                                                {`${t('LABEL.MAP.MAP_LAYER.RECEIVE_SIGNAL')} 70 - 90%`}
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Checkbox
                                            name="antennaPattern"
                                            label={t('LABEL.MAP.MAP_LAYER.STATION_WAVE')}
                                            labelPlacement="end"
                                            checked={isCheckAntennaPatternLayer}
                                            onClick={onCheckAntennaPatternLayer}
                                            overrideClass={{ root: classes.checkbox, checked: classes.checkboxChecked }}
                                            classNameLabel={classes.labelCheckbox}
                                        />
                                        <div className={classes.listContent}>
                                            <Typography
                                                gutterBottom
                                                component="div"
                                                // style={{ paddingTop: '8px' }}
                                                className={classes.labelSubCheckbox}
                                            >
                                                <img
                                                    style={{
                                                        height: '32px',
                                                        imageRendering: '-webkit-optimize-contrast',
                                                    }}
                                                    src={`${process.env.REACT_APP_IMAGE_PATH}/assets/image/antenna_pattern.png`}
                                                />
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </StyledDivContent>
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </Paper>
    )
}

export default MapLayer

const useStyles = makeStyles((theme: Theme) => ({
    paperRoot: {
        borderRadius: '5px !important',
    },
    paper: {
        borderRadius: '5px !important',
        marginTop: theme.spacing(1),
        width: '320px',
        [theme.breakpoints.down('sm')]: {
            width: '270px',
        },
    },
    listContent: {
        paddingLeft: theme.spacing(3.5),
    },
    labelSquare: {
        float: 'left',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        marginRight: theme.spacing(1),
    },
    labelSquareOuter: {
        float: 'left',
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        marginRight: theme.spacing(1),
    },
    checkbox: {
        color: `${theme.palette.primary.dark} !important`,
    },
    checkboxChecked: {
        color: `${theme.palette.primary.dark} !important`,
    },
    labelTitle: {
        fontSize: '16px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px !important',
        },
    },
    labelCheckbox: {
        fontSize: '15px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '13px !important',
        },
    },
    labelSubCheckbox: {
        fontSize: '14px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px !important',
        },
    },
    iconColor: {
        width: '24px',
        height: '24px',
        '&:hover path': {
            fill: `${theme.palette.primary.main} !important`,
        },
        '&:hover circle': {
            fill: `${theme.palette.primary.main} !important`,
        },
    },
}))

const StyledDivTitle = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    backgroundColor: `${theme.palette.background.default} !important`,
    borderBottom: `1px solid ${theme.palette.primary.light} !important`,
}))

const StyledDivContent = styled('div')(({ theme }) => ({
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
}))

const IconPinStation = styled('img')(({ theme }) => ({
    height: '30px',
}))
